import Alpine from 'alpinejs'

Alpine.data('buyNowPreview', (productId: string, priceMCU: number, previewUrl: string, confirmUrl: string, errorMessage: string) => ({

    alert: {
        type: null, // info or error
        title: null,
        text: null,
        close: null,
        reload: false, // reload overlay once alert is closed
    },
    
    preview: {
        isFreeShipping: false,
        variantName: null,
        addressLines: [],
        paymentMethod: null,
    },

    autoPreviewOnVariantSelected: false,
    show: null, // null, preview, pending, alert, success
    variantId: null,

    reset() {
        this.show = null
        this.alert = {
            type: null,
            title: null,
            text: null,
            close: null,
            reload: false,
        }
        this.preview = {
            variantName: null,
            addressLines: [],
            paymentMethod: null,
            shippingTimeHtml: null,
            shippingCostsHtml: null,
        }
    },
    
    setVariant(variantId) {
        this.variantId = variantId
        if(this.autoPreviewOnVariantSelected) {
            this.submitPreview()
        }
    },

    async submitPreview() {
        if(!this.variantId) {
            this.$dispatch('variant-selection-requested')
            this.autoPreviewOnVariantSelected = true
            return
        }
        this.autoPreviewOnVariantSelected = false
        this.show = 'pending'
        
        return fetch(previewUrl, {
            method: 'POST',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                productId: productId,
                variantId: this.variantId,
                priceMCU: priceMCU,
            })
        }).then(response => {
            
            if(!response.ok) {
                throw new Error('response status '+response.status+'/'+response.statusText)
            }
            return response.json()
            
        }).then(data => {
            
            this.reset()
            if(data.status === 'success') {
                
                this.show = 'preview'
                this.preview = data.preview
                
            } else if(data.status === 'unauthenticated') {
                
                document.location.reload()
                
            } else if(data.alert) {
                
                this.show = 'alert'
                this.alert = Object.assign(this.alert, data.alert)
                
            } else {
                
                throw new Error('invalid response')
                
            }
            
        }).catch(error => {
            
            console.log(error)
            alert(errorMessage)
            document.location.reload()
            
        })
    },

    async submitConfirm() {
        if(!this.preview.paymentMethod) {
            return
        }
        this.show = 'pending'

        return fetch(confirmUrl, {
            method: 'POST',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                productId: productId,
                variantId: this.variantId,
                priceMCU: priceMCU,
            })
        }).then(response => {

            if(!response.ok) {
                throw new Error('response status '+response.status+'/'+response.statusText)
            }
            return response.json()

        }).then(data => {

            this.reset()
            if(data.status === 'success') {

                this.show = 'success'
                this.$dispatch('buy-now-conversion', { 
                    productId: productId, 
                    variantId: this.variantId,
                    transactionId: data.transaction.id,
                    transactionAmount: priceMCU/100,
                    metaEventId: data.transaction.metaEventId,
                })

            } else if(data.status === 'unauthenticated') {

                document.location.reload()

            } else if(data.alert) {

                this.show = 'alert'
                this.alert = Object.assign(this.alert, data.alert)

            } else {

                throw new Error('invalid response')

            }

        }).catch(error => {

            console.log(error)
            alert(errorMessage)
            document.location.reload()

        })
    },
    
    close() {
        if(this.show === 'pending') {
            return
        }
        if(this.alert.reload) {
            document.location.reload()
        } else {
            this.reset()
        }
    },

}))